<template>
  <b-navbar toggleable="sm" type="light" class="w-100">
    <div class="container">
      <router-link to="/">
        <b-navbar-brand>
          <img src="../assets/images/logo.jpg" alt="logo" />
        </b-navbar-brand>
      </router-link>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="menu-list ml-auto" style="align-items: center">
          <b-nav-item :href="`${publicPath}catalogo.pdf`" download="download">Catálogo</b-nav-item>

          <router-link to="/contato">
            <b-nav-item href="/contato">Contato</b-nav-item>
          </router-link>
          <b-nav-item-dropdown text="Produtos" right>
            <b-dropdown-item href="/grades">
              <router-link to="/grades">Grades</router-link>
            </b-dropdown-item>
            <b-dropdown-item href="/degraus">
              <router-link to="/degraus">Degraus</router-link>
            </b-dropdown-item>
            <b-dropdown-item href="/gradis">
              <router-link to="/gradis">Gradis</router-link>
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/_standard.scss";
nav {
  position: fixed;
  width: 100vw;

  .navbar-collapse {
    margin-top: 20px;
  }

  .navbar-nav {
    a {
      color: $primary !important;
      font-weight: 700;

      &:hover {
        text-decoration: none;
      }
    }
  }

  .dropdown-menu {
    li:active,
    li:focus {
      background-color: white;
    }
  }

  .dropdown-item:active {
    background-color: white;
  }
}
</style>
